import React, { Component } from "react";
import { Card, Button, Container } from "react-bootstrap";
import ProductData from '../data/products.json'
import "./Products.css";

class Products extends Component {


  render() {
    return (
      <div>
        <div className="banner_all">
          <Container>
            <h1>Product</h1>
          </Container>
        </div>

        <Container>
          <div className="row">
          {ProductData.map((postDetail, index)=>{
        return <div className="col-sm-12 col-md-6 col-lg-4 prodcard">
           <Card>
                <Card.Img variant="top" src={`assets/images/${postDetail.image}.jpg`}  />
                <Card.Body>
                  <Card.Title>{postDetail.title}</Card.Title>
                  <Card.Text>
                  {postDetail.desc}
                  </Card.Text>
                  {/* <Button variant="primary">Go somewhere</Button> */}
                </Card.Body>
              </Card>
        </div>

        })}

      
          </div>
        </Container>
      </div>
    );
  }
}

export default Products;
